export default {
      id: "arrowUpRed-usage",
      viewBox: "0 0 17 18",
      url: __webpack_public_path__ + "icons.svg#arrowUpRed",
      toString: function () {
        return this.url;
      }
    }